<div class="container landing-container pb-5">
  <div class="table-wrapper">
    <table class="custom-table">
      <thead>
        <tr>
          <th>File Name</th>
          <th>Image Count</th>
          <th>Status</th>
          <th>Created By</th>
          <th>Created Date</th>
        </tr>
      </thead>
      <tbody (scroll)="onScroll($event)">
        <tr *ngIf="!(visibleData.length > 0)">
          <td colspan="5" class="center">No Records Found!</td>
        </tr>
        <tr *ngFor="let item of visibleData" class="clickable-row" (click)="openimageConfigurationModal(item.imageData, item.batchId)">
          <td>{{item.csvFileName}}</td>
          <td>{{item.totalProcessedImages}} / {{item.totalImages}}</td>
          <td>{{item.totalProcessedImages > 0 ? 'In Progress' : 'Pending'}}</td>
          <td>{{item.createdBy?.title}}</td>
          <td>{{item.createdOn | date:'MMM d, y'}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
